import React from 'react';
import { Button as ButtonReactstrap } from 'reactstrap';

export function ButtonFilter({
  color,
  title,
  onClick,
  label,
  isActive,
  children
}) {
  return (
    <ButtonReactstrap
      color={color}
      outline
      size="sm"
      type="button"
      active={isActive}
      title={title}
      onClick={onClick}
      style={{
        margin: '0rem',
        minHeight: '1rem',
        height: 'auto',
        width: 'auto',
        borderRadius: '0.5rem',
        fontSize: '13px'
      }}
    >
      {children}
      {label}
    </ButtonReactstrap>
  );
}
